import { useCallback, useEffect } from 'react';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { isEmpty } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import SectionHeader from 'components/atoms/GefMui/SectionHeader';
import TableHasNoResults from 'components/atoms/GefMui/TableHasNoResults';
import fetch from 'features/common/fetch';
import reported from 'features/views/productionReport';

import ActionButtons from './ActionButtons';
import ReportedDocumentTableRow from './ReportedDocumentTableRow';

const fetchStorePath = `${fetch.constants.urls.productionDocuments}.reported`;

const ReportedDocumentTable = () => {
	const dispatch = useDispatch();

	const documents = useSelector(reported.selectors.getDocuments);

	useEffect(() => {
		dispatch(reported.actions.loadDocuments());
	}, [dispatch]);

	const handleReload = useCallback(() => {
		dispatch(reported.actions.loadDocuments());
	}, [dispatch]);

	return (
		<Stack spacing={1}>
			<SectionHeader text={getLabelMessage('producedProductionReport:documentTitle')} />
			<ComponentLoader fetchStorePath={fetchStorePath} onReload={handleReload}>
				<Table size="small">
					<TableHead>
						<TableRow>
							<TableCell>{getLabelMessage('producedProductionReport:client')}</TableCell>
							<TableCell>{getLabelMessage('producedProductionReport:reportedDate')}</TableCell>
							<TableCell>{getLabelMessage('producedProductionReport:policyNo')}</TableCell>
							<TableCell>{getLabelMessage('producedProductionReport:document')}</TableCell>
							<TableCell>{getLabelMessage('producedProductionReport:scan')}</TableCell>
							<TableCell>{getLabelMessage('producedProductionReport:name')}</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{isEmpty(documents) ? (
							<TableHasNoResults />
						) : (
							documents.map((doc) => (
								<TableRow key={doc.id}>
									<ReportedDocumentTableRow doc={doc} />
								</TableRow>
							))
						)}
					</TableBody>
				</Table>
				<ActionButtons />
			</ComponentLoader>
		</Stack>
	);
};

export default ReportedDocumentTable;
